<template>
  <v-data-table
    :headers="headers"
    :items="emailQuotes"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="EmailQuote-button-new"
          @click="$router.push({
            name: 'email-quote-EditEmailQuote'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'email-quote-EditEmailQuote',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListEmailQuote',
  module: 'EmailQuote',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('emailQuotes', ['emailQuotes']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('recipients'),
          value: 'recipients',
        },
        {
          text: this.$$t('subject'),
          value: 'subject',
        },
        {
          text: this.$$t('body'),
          value: 'body',
        },
        {
          text: this.$$t('quoteId'),
          value: 'quoteId',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_emailQuotes();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('emailQuotes', ['LOAD_emailQuotes', 'DELETE_emailQuote']),
    /** Delete EmailQuote from the collection
     */
    async remove(EmailQuote) {
      this.isLoading = true;
      await this.DELETE_EmailQuote(EmailQuote);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# EmailQuote example

'''js
<EmailQuote />
'''
</docs>
